import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { CustomEventSchema } from "components/Layout/CustomEvent/SchemaForm/CustomEventSchema";
import { useMessage } from "hooks/intl";
import { links } from "utilities/links";
import { useStyles } from "./CustomEventSchema";

export function AddCustomEventSchema() {
  const { message } = useMessage();
  const classes = useStyles();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "customEventSchemas" }),
      path: links.customEventsSchemaList,
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "addEventSchema" })}
        clearLink={links.customEventsSchemaList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.form}>
        <CustomEventSchema />
      </div>
    </>
  );
}
